import { downloadFile } from './exportExcel';
export async function exportCsv(data, config) {
    const { unparse } = await import('papaparse');
    const text = unparse(data, config);
    const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
    downloadFile(config.fileName, blob);
}
